/* eslint-disable react-hooks/exhaustive-deps */
import { useApolloClient } from "@apollo/client";
import { Box, Card, CardContent, Chip, Grid, Typography } from "@mui/material";
import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useRecoilState, useSetRecoilState } from "recoil";
import { getCandidateByID } from "../../../graphql/query";
import { getDetailCandidate } from "../../../shared/atom/detailCandidate";
import {
  cfitIsDone,
  preAssesmentIsDone,
  papikostikIsDone,
} from "../../../shared/atom/getLogMostest";
import { swalAlert } from "../../../shared/helpers";
import assessment from "../../../components/Layout/assets/assessment-1.jpg";
import { globalLoadingAtom } from "../../../shared/globalStates";
function Assesment() {
  const [candidate, setDetailCandidate] = useState([]);
  const setGlobalDetailCandidate = useSetRecoilState(getDetailCandidate);
  const [CFIT, setCFIT] = useRecoilState(cfitIsDone);
  const [preAssesment, setPreAssesment] = useRecoilState(preAssesmentIsDone);
  const [papikostik, setPapikostik] = useRecoilState(papikostikIsDone);
  const [isPsikotest, setisPsikotest] = useState({
    psikotest: true,
    mostest1: false,
    mostest2: false,
  });
  const [timeup, setTimeup] = useState(false);
  const setLoading = useSetRecoilState(globalLoadingAtom);
  const client = useApolloClient();

  useEffect(() => {
    setLoading(true);
    getCandidateByID(client).then((response) => {
      setDetailCandidate(response);
      setGlobalDetailCandidate(response);
      setPreAssesment(response.is_pre_assessment_done);
      if (!!response.cfit_score) {
        setCFIT(true);
      }
      setPapikostik(response.is_papikostik_done);
    });
  }, []);

  useEffect(() => {
    if (isEmpty(candidate)) return;
    setLoading(false);
    const { psikotest_date, mostest1, mostest2 } = candidate;
    if (!psikotest_date) {
      setisPsikotest({ psikotest: false });
      setTimeup(false);
    } else {
      const hourLimit = 3600000;
      const psikotestDate = new Date(psikotest_date).getTime();
      const now = Date.now();
      const calc_time = now - psikotestDate;
      if (calc_time >= 0) {
        setisPsikotest({ psikotest: false });
        setTimeup(false);
        localStorage.removeItem("values");
      } else if (calc_time >= hourLimit) {
        setisPsikotest({ psikotest: false });
        setTimeup(true);
        localStorage.removeItem("values");
      } else {
        setTimeup(false);
        setisPsikotest({
          psikotest: true,
          mostest1: mostest1,
          mostest2: mostest2,
        });
      }
    }
  }, [candidate]);

  const ConditionalLink = ({ children, to, condition, timeup }) =>
    !!condition && to ? (
      <Link to={to}>{children}</Link>
    ) : timeup ? (
      <Box
        onClick={() =>
          swalAlert({
            text: "Batas waktu pengerjaan telah habis, Anda sudah tidak diperkenankan untuk mengerjakan psikotest ini.",
            title: "Waktu habis",
          })
        }>
        {children}
      </Box>
    ) : (
      <Box
        onClick={() =>
          swalAlert({
            text: "Maaf anda belum diperkenankan untuk mengerjakan psikotest ini. Silahkan hubungi HR jika terjadi kesalahan.",
            title: "Error",
          })
        }>
        {children}
      </Box>
    );

  return (
    <Box width="80%" margin="auto">
      <Grid container spacing={5} pt="25px" px="10px">
        <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
          <Link to="/career/pre-assessment">
            <Card
              className="shadow-soft-s4-hover"
              variant="outlined"
              sx={{ cursor: "pointer", textAlign: "center" }}>
              <CardContent>
                <img src={assessment} alt="Assessment 1" width="100%" height="auto" />
                <Typography
                  variant="h4"
                  component="h4"
                  color="primary"
                  textTransform="uppercase"
                  sx={{ mb: "15px" }}>
                  Pre-Assessment
                </Typography>

                {preAssesment ? (
                  <>
                    <Chip
                      size="large"
                      color="success"
                      label="Telah Selesai"
                      sx={{
                        margin: "10px",
                      }}
                    />
                    <p className="text-success-main font-size-main">
                      Maaf anda tidak diperkenankan untuk mengerjakan lebih dari satu kali.
                    </p>
                  </>
                ) : (
                  <>
                    <Chip
                      size="large"
                      label="Perlu Dikerjakan"
                      sx={{
                        margin: "10px",
                      }}
                    />
                    <Typography className="text-neutral-main font-size-main">
                      Pada bagian ini anda diminta untuk menjawab beberapa pertanyaan tentang
                      pekerjaan anda sebelumnya.
                    </Typography>
                  </>
                )}
              </CardContent>
            </Card>
          </Link>
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
          <ConditionalLink to="/career/mostest-1" condition={isPsikotest.mostest1} timeup={timeup}>
            <Card
              className="shadow-soft-s4-hover"
              variant="outlined"
              sx={{ cursor: "pointer", textAlign: "center" }}>
              <CardContent>
                <img src={assessment} alt="Assessment 1" width="100%" height="auto" />
                <Typography
                  variant="h4"
                  component="h4"
                  color="primary"
                  textTransform="uppercase"
                  sx={{ mb: "15px" }}>
                  MOSTEST 1
                </Typography>
                {CFIT ? (
                  <>
                    <Chip
                      size="large"
                      color="success"
                      label="Telah selesai"
                      sx={{
                        margin: "10px",
                        display: !isPsikotest.mostest1 && "none",
                      }}
                    />
                    <p
                      className="text-success-main font-size-main"
                      style={{
                        display: !isPsikotest.mostest1 && "none",
                      }}>
                      Maaf anda tidak diperkenankan untuk mengerjakan lebih dari satu kali.
                    </p>
                  </>
                ) : (
                  <>
                    <Chip
                      size="large"
                      label="Perlu Dikerjakan"
                      sx={{
                        margin: "10px",
                        display: !isPsikotest.mostest1 && "none",
                      }}
                    />
                    <Typography
                      sx={{
                        display: !isPsikotest.mostest1 && "none",
                      }}>
                      Pada bagian ini anda diminta untuk mengerjakan dengan teliti dan cepat.
                      Silahkan ikuti intruksi yang ada dan tidak diperkenankan untuk dikerjakan oleh
                      orang lain.
                    </Typography>
                  </>
                )}
              </CardContent>
            </Card>
          </ConditionalLink>
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
          <ConditionalLink to="/career/mostest-2" condition={isPsikotest.mostest2} timeup={timeup}>
            <Card
              className="shadow-soft-s4-hover"
              variant="outlined"
              sx={{ cursor: "pointer", textAlign: "center" }}>
              <CardContent>
                <img src={assessment} alt="Assessment 1" width="100%" height="auto" />
                <Typography
                  variant="h4"
                  component="h4"
                  color="primary"
                  textTransform="uppercase"
                  sx={{ mb: "15px" }}>
                  MOSTEST 2
                </Typography>
                {papikostik ? (
                  <>
                    <Chip
                      size="large"
                      color="success"
                      label="Telah selesai"
                      sx={{
                        margin: "10px",
                        display: !isPsikotest.mostest2 && "none",
                      }}
                    />
                    <p
                      className="text-success-main font-size-main"
                      style={{
                        display: !isPsikotest.mostest2 && "none",
                      }}>
                      Maaf anda tidak diperkenankan untuk mengerjakan lebih dari satu kali.
                    </p>
                  </>
                ) : (
                  <>
                    <Chip
                      size="large"
                      label="Perlu Dikerjakan"
                      sx={{
                        margin: "10px",
                        display: !isPsikotest.mostest2 && "none",
                      }}
                    />
                    <Typography
                      sx={{
                        display: !isPsikotest.mostest2 && "none",
                      }}>
                      Pada bagian ini anda diminta untuk memberikan informasi dengan
                      sejujur-jujurnya dan anda diperkenankan dalam melanjutkan soal kapan pun.
                    </Typography>
                  </>
                )}
              </CardContent>
            </Card>
          </ConditionalLink>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Assesment;
